import * as React from "react";
import PropTypes from "prop-types";

const TrailDetails = ({ details }) => {
  let detailsArray = [];
  if (details.miles) {
    detailsArray.push(details.miles + " miles");
  }
  if (details.descent) {
    detailsArray.push(details.descent + " descent");
  }
  if (details.elevationGain) {
    detailsArray.push(details.elevationGain + " elevation gain");
  }
  if (details.high) {
    detailsArray.push(details.high + " high");
  }
  if (details.low) {
    detailsArray.push(details.low + " low");
  }
  if (details.aveGrade) {
    detailsArray.push(details.aveGrade + " average grade");
  }
  if (details.maxGrade) {
    detailsArray.push(details.maxGrade + " max grade");
  }

  return <>{detailsArray.join(" / ")}</>;
};

TrailDetails.propTypes = {
  details: PropTypes.object,
};

export default TrailDetails;
